import { PractitionerOrOrganization } from '../../../../../../interfaces/interfaces';

const infoWindowModule = ({ name }: PractitionerOrOrganization, map: google.maps.Map | google.maps.StreetViewPanorama | null | undefined) => {
  const infoWindowContent = `<div>${name}</div>`;
  const infowindow = new google.maps.InfoWindow({
    content: infoWindowContent,
    disableAutoPan: true,
  });

  const infoWindowOpen = (marker: google.maps.Marker) =>
    infowindow.open({
      anchor: marker,
      map,
      shouldFocus: false,
    });

  const infoWindowClose = () => infowindow.close();

  const infoWindowHandlerForMousOverOrOut = (value: string, marker: google.maps.Marker) => () => {
    switch (value) {
      case 'open':
        infoWindowOpen(marker);
        break;
      case 'close':
        infoWindowClose();
        break;
      default:
        break;
    }
  };

  const selectItemInSearchResult = (id: string) => () => {
    const elem = document.getElementById(id);
    if (elem) {
      elem.classList.add('Mui-selected');
    }
  };

  const deselectItemInSearchResult = (id: string) => () => {
    const elem = document.getElementById(id);
    if (elem) {
      elem.classList.remove('Mui-selected');
    }
  };

  const scrollSelectedItemInSearchResult = (id: string) => () => {
    const activElement = document.getElementById(id);
    activElement?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  };

  const infoWindowHandlerForCustomEvent = (marker: google.maps.Marker, svgMarker: google.maps.Symbol) => (e: Event) => {
    const { detail } = e as CustomEvent;
    if (detail) {
      marker.setIcon(svgMarker);
      marker.setZIndex(1000);
      infoWindowOpen(marker);
    } else {
      marker.setIcon(null);
      marker.setZIndex(0);
      infoWindowClose();
    }
  };

  return {
    infoWindowHandlerForMousOverOrOut,
    infoWindowHandlerForCustomEvent,
    selectItemInSearchResult,
    deselectItemInSearchResult,
    scrollSelectedItemInSearchResult,
  };
};

export default infoWindowModule;
